import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

/**
 * Heal a stale URL.
 *
 * A slug that has been retired still resolves — the server follows `slug_history` — so an
 * old link opens the right record. But the address bar would then keep showing a name the
 * record no longer has, and every copy of that link taken from it would propagate the dead
 * slug onward. Once the response tells us the canonical slug, the URL quietly becomes it.
 *
 * `replace`, and carrying the existing state: this is a correction, not a navigation. It
 * must not add a history entry — otherwise Back would step from the corrected URL to the
 * stale one and immediately correct it again, trapping the reader — and it must not drop
 * the modal's background, which is what closing depends on.
 */
export function useCanonicalSlug(routeSlug: string | undefined, canonical: string | undefined, prefix: string): void {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!routeSlug || !canonical || routeSlug === canonical) return;
    void navigate(`${prefix}/${canonical}`, { replace: true, state: location.state });
  }, [routeSlug, canonical, prefix, navigate, location.state]);
}
